const HomeInfoConfirm = ({ fields, viewMode, member }) => {

  return (
    <>
              <h3>自宅</h3>
              <dl>
                <dt>郵便番号<span class="red">*</span></dt>
                <dd>{viewMode ? member.homePostalCode : fields.homePostalCode}&nbsp;</dd>
                <dt>現住所<span class="red">*</span></dt>
                <dd>{viewMode ? member.homeAddress.replace('#',' ') : fields.homeAddress.replace('#',' ')}&nbsp;</dd>
                <dt>現住所（フリガナ）<span class="red">*</span></dt>
                <dd>{viewMode ? member.homeAddressKana : fields.homeAddressKana}&nbsp;</dd>
                <dt>電話番号<span class="red">*</span></dt>
                <dd>{viewMode ? member.homeTel : fields.homeTel}&nbsp;</dd>
                <dt>FAX</dt>
                <dd>{viewMode ? member.homeFax : fields.homeFax}&nbsp;</dd>
                </dl>
    </>
  );
}

export default HomeInfoConfirm;
